import type * as React from 'react';

function SvgBettingSplits(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M21 22H3C2.4473 22 2 21.5522 2 21C2 20.4478 2.4473 20 3 20H21C21.5527 20 22 20.4478 22 21C22 21.5522 21.5527 22 21 22Z"
        fill="currentColor"
      />
      <path
        d="M3 22C2.4473 22 2 21.5522 2 21V3C2 2.4478 2.4473 2 3 2C3.5527 2 4 2.4478 4 3V21C4 21.5522 3.5527 22 3 22Z"
        fill="currentColor"
      />
      <path
        d="M16 16.75H7C6.5859 16.75 6.25 16.4141 6.25 16C6.25 15.5859 6.5859 15.25 7 15.25H16C16.4141 15.25 16.75 15.5859 16.75 16C16.75 16.4141 16.4141 16.75 16 16.75Z"
        fill="currentColor"
      />
      <path
        d="M12 6.75H7C6.5859 6.75 6.25 6.4141 6.25 6C6.25 5.5859 6.5859 5.25 7 5.25H12C12.4141 5.25 12.75 5.5859 12.75 6C12.75 6.4141 12.4141 6.75 12 6.75Z"
        fill="currentColor"
      />
      <path
        d="M20 11.75H7C6.5859 11.75 6.25 11.4141 6.25 11C6.25 10.5859 6.5859 10.25 7 10.25H20C20.4141 10.25 20.75 10.5859 20.75 11C20.75 11.4141 20.4141 11.75 20 11.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgBettingSplits;
